import API from '../interceptors/Api';

const baseRoute = '/workspaces';

export const createWorkspace = (data) => API.post(baseRoute, data);

export const getWorkspace = (workspaceId) => API.get(`${baseRoute}/${workspaceId}`);

export const getWorkspaces = (params) => API.get(baseRoute, { params });

export const updateWorkspaceMetadata = (key, value) => API.put(`${baseRoute}/metadata/${key}/${value}`);

export const updateWorkspace = (id, data) => API.put(`${baseRoute}/${id}`, data);

export const deleteWorkspace = ({ id, name }) => API.delete(`${baseRoute}/${id}`, { params: { name } });

export const getWorkspaceConfig = (workspaceId) => API.get(`${baseRoute}/${workspaceId}/config`);
